const filteredItems = [
  {
    id: 'all',
    label: 'global.filter.all',
  },
  {
    id: 'Success',
    label: 'global.success2',
  },
  {
    id: 'Failed',
    label: 'global.failed',
  },
]

export default filteredItems
